module.exports = __webpack_public_path__ + "img/68.a934f5b6.jpg";